import React from 'react';
import ExpandedComponent from "../../microComponents/tablePages/ExpandedComponent";

const ExpandedBatch = ({item}) => {
    return (
        <ExpandedComponent items={[
            {title: 'شماره بچ', value: item.batchNumber,class:'2xs:hidden'},
            {title: 'محصول', value: item.product,class:'3xs:hidden'},
            {title: 'چاپ شده', value: item.printedCounter,class:'3xs:hidden'},
            {title: 'تحویل به انبار', value: item.registredCounter,class:'sm:hidden'},
            {title: 'ابطال', value: item.cancleCounter,class:'md:hidden'},
            {title: 'در حال بررسی', value: item.quarantineCounter,class:'2md:hidden'},
            {title: 'امحا', value: item.destroyedCounter,class:'lg:hidden'},
            {title: 'بازسازی شده', value: item.description,class:'lg:hidden'},
            // {title: 'تعداد در پالت', value: item.description,class:'lg:hidden'},
            {title: 'کنترل کیفی', value: item.qualityControlAdmin,class:'lg:hidden'},
            {title: 'تاریخ ثبت', value: item.created,class:'lg:hidden'},
            {title: 'زمان پایان', value: item.stopDate,class:'lg:hidden'},


        ]}/>
    );
};

export default ExpandedBatch;